module.exports = __webpack_public_path__ + "static/img/discount_bg.65b8ab17.png";